import React from "react";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";

import { koraxTokens } from "../../designSystem";

const useStyles = makeStyles(theme => ({
  root: {
    flex: "none",
    marginLeft: "auto",

    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    gap: koraxTokens.spacing.xs,

    "& > *": {
      margin: 0
    },

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: 0,
      justifyContent: "flex-start"
    }
  }
}));

const MainHeaderButtonsWrapper = ({ children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, className)}>
      {children}
    </div>
  );
};

export default MainHeaderButtonsWrapper;
